import React from 'react';
import _ from 'lodash';

// mui
import { Box, Divider } from '@mui/material';

// components
import SimpleTooltip from '../../../../../../components/SimpleTooltip';
import { CowbellAccountProfileLink } from '../../../../../accounts/admin/profile/CowbellAccountProfileLink';
import {
  AccountData,
  CaptionTypography as Typography,
  Flexbox,
} from '../policy-details.shared-components.utils';

// utils
import { truncateString } from '../../../../../../utils';

import { useCowbellTranslations } from '../../../../../../i18n/translations';
import { getProjectedRevenue } from '../../../../../../accounts/cowbell-accounts-listing/helpers';
import { useFetchOwnershipTypes } from '../../../../../agencies/quotes/PrimeX/AccountDetails/forms/useFetchOwnershipTypes';
import { REDACTED_FIELD } from '../../../../../../config/logrocket';

export const OrganizationDetails = ({
  policy = {},
  account = {},
  latestRiskSelected = false,
}) => {
  const { t } = useCowbellTranslations();

  const {
    industryCode,
    dunsNumber = '',
    domainName,
    domains,
    url,
    entityType,
    isFranchise,
    ownershipType,
    noOfEmployeesAll,
    // @ts-expect-error TS(2339): Property 'firmographicData' does not exist on type... Remove this comment to see the full error message
  } = policy.firmographicData;

  const fullPrimaryIndustry =
    // @ts-expect-error TS(2339): Property 'firmographicData' does not exist on type... Remove this comment to see the full error message
    policy?.firmographicData?.ui_primaryIndustryDescription ||
    // @ts-expect-error TS(2339): Property 'firmographicData' does not exist on type... Remove this comment to see the full error message
    policy?.firmographicData?.primaryIndustry;

  // @ts-expect-error TS(2339): Property 'firmographicData' does not exist on type... Remove this comment to see the full error message
  const revenue = getProjectedRevenue(policy.firmographicData);

  const primaryIndustry = truncateString(fullPrimaryIndustry, 25);
  // @ts-expect-error TS(2339): Property 'otherDomains' does not exist on type '"-... Remove this comment to see the full error message
  const { otherDomains, fullOtherDomains } = useOtherDomains({ domains });

  // most recent data
  // @ts-expect-error TS(2345): Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
  const accountRevenue = getProjectedRevenue(account);
  const {
    // @ts-expect-error TS(2339): Property 'otherDomains' does not exist on type '"-... Remove this comment to see the full error message
    otherDomains: accountOtherDomains,
    // @ts-expect-error TS(2339): Property 'fullOtherDomains' does not exist on type... Remove this comment to see the full error message
    fullOtherDomains: accountFullOtherDomains,
    // @ts-expect-error TS(2339): Property 'domains' does not exist on type '{}'.
  } = useOtherDomains({ domains: account.domains });
  const accountFullPrimaryIndustry = _.get(account, 'primaryIndustry', '-');
  const accountPrimaryIndustry = truncateString(accountFullPrimaryIndustry, 25);
  const { getOwnershipTypeLabel } = useFetchOwnershipTypes();
  const ownershipTypeLabel =
    // @ts-expect-error TS(2339): Property 'ownershipType' does not exist on type '{... Remove this comment to see the full error message
    getOwnershipTypeLabel(account?.ownershipType) ?? '-';

  return (
    <>
      <Divider style={{ width: '100%', margin: '1rem 0 0.5rem' }} />
      <Flexbox>
        <Typography variant="subtitle2" color="primary">
          DETAILS
        </Typography>
        <CowbellAccountProfileLink account={account} />
      </Flexbox>
      <Divider style={{ width: '100%', margin: '0.5rem 0 1rem' }} />
      <Box display="flex">
        <Box width="50%" marginRight={1}>
          <Flexbox>
            <Typography variant="caption">Industry Code</Typography>
            <Box>
              <Typography>{industryCode || '-'}</Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'industryCode' does not exist on type '{}... Remove this comment to see the full error message
                data={account.industryCode}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography variant="caption">Projected {t('revenue')}</Typography>
            <Box>
              <Typography>{revenue}</Typography>
              <AccountData data={accountRevenue} show={latestRiskSelected} />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>DUNS Number</Typography>
            <Box>
              <Typography>{dunsNumber !== '' ? dunsNumber : '-'}</Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'dunsNumber' does not exist on type '{}'.
                data={account.dunsNumber !== '' ? account.dunsNumber : '-'}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Primary Web Domain</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography>{domainName !== '' ? domainName : '-'}</Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'domainName' does not exist on type '{}'.
                data={account.domainName !== '' ? account.domainName : '-'}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Secondary Web Domain(s)</Typography>
            <Box className={REDACTED_FIELD}>
              <SimpleTooltip title={fullOtherDomains} show={!!otherDomains}>
                <Typography>{otherDomains || '-'}</Typography>
              </SimpleTooltip>
              <SimpleTooltip
                title={accountFullOtherDomains}
                show={!!accountOtherDomains}
              >
                <AccountData
                  data={accountOtherDomains || '-'}
                  show={latestRiskSelected}
                />
              </SimpleTooltip>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Url</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography
                component="a"
                href={url ? `https://${url}` : null}
                target="_blank"
                className="link-underlined--hover"
              >
                {url || '-'}
              </Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'url' does not exist on type '{}'.
                data={account.url || '-'}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box width="50%" marginLeft={1}>
          <Flexbox>
            <Typography>Year Established</Typography>
            <Box mb={latestRiskSelected ? '1.8rem' : '0'}>
              {/* @ts-expect-error TS(2339): Property 'yearEstablished' does not exist on type ... Remove this comment to see the full error message */}
              <Typography>{account.yearEstablished}</Typography>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Entity Type</Typography>
            <Box>
              <Typography>{entityType || '-'}</Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'entityType' does not exist on type '{}'.
                data={account.entityType || '-'}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Subsidiary/Franchisee</Typography>
            <Box>
              <Typography>{isFranchise ? 'Yes' : 'No'}</Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'isFranchise' does not exist on type '{}'... Remove this comment to see the full error message
                data={account.isFranchise ? 'Yes' : 'No'}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Industry</Typography>
            <Box>
              <SimpleTooltip title={fullPrimaryIndustry}>
                <Typography>{primaryIndustry}</Typography>
              </SimpleTooltip>
              <SimpleTooltip title={accountFullPrimaryIndustry}>
                <AccountData
                  data={accountPrimaryIndustry}
                  show={latestRiskSelected}
                />
              </SimpleTooltip>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Ownership Type</Typography>
            <Box>
              <Typography>{ownershipType || '-'}</Typography>
              <AccountData
                data={ownershipTypeLabel}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Number of Employees</Typography>
            <Box>
              <Typography>{noOfEmployeesAll}</Typography>
              <AccountData
                // @ts-expect-error TS(2339): Property 'noOfEmployeesAll' does not exist on type... Remove this comment to see the full error message
                data={account.noOfEmployeesAll || '-'}
                show={latestRiskSelected}
              />
            </Box>
          </Flexbox>
        </Box>
      </Box>
    </>
  );
};

const useOtherDomains = ({ domains }: any) => {
  return React.useMemo(() => {
    if (!domains) {
      return '-';
    }

    const commaSeparatedDomains = domains
      .map((_item: any) => (typeof _item === 'string' ? _item : _item.domain))
      .join(', ');

    return {
      otherDomains: truncateString(commaSeparatedDomains, 25),
      fullOtherDomains: commaSeparatedDomains,
    };
  }, [domains]);
};
